import Vue from 'vue';

Vue.directive('focus', {
    inserted(el, binding) {
        let x = null;
        let y = null;
        const value = binding.value;

        if (Array.isArray(value) && value.length == 2) {
            x = value[0];
            y = value[1];
        } else if (value != null) {
            x = value.focal_x;
            y = value.focal_y;
        }

        if (x && y) {
            el.style.backgroundPosition = `${x * 100}% ${y * 100}%`;
        }
    }
});


// WEBPACK FOOTER //
// ../default-js/js/directives/focusArea.js